<figure>
	<img
		*ngIf="path"
		[defaultImage]="load ? '/assets/images/placeholder.gif' : ''"
		[lazyLoad]="path"
		errorImage="../../assets/images/error-image.png"
		[alt]="alt"
		[title]="title"
		/>
</figure>
